import React from 'react';
import './Section.css';

const Section = ({
    children,
    className = '',
    background = 'white',
    id = ''
}) => {
    return (
        <section
            id={id}
            className={`section bg-${background} ${className}`}
        >
            <div className="container">
                {children}
            </div>
        </section>
    );
};

export default Section;
